export const initialState: HomePageReducerState = {
    loading: true,
    locations: [],
    specialDeals: [],
    promotions: [],
    services: [],
    talksAboutUsList: [],
};

export enum ActionEnum {
    INITIAL_PAGE_COMPLETED = "INITIAL_PAGE_COMPLETED"
}

type Action =
    | {
        type: ActionEnum.INITIAL_PAGE_COMPLETED;
        payload: {
            locations: CarSearchLocation[];
            specialDeals: Car[];
            promotions: Promotion[];
            services: Service[];
            talksAboutUsList: TalkAboutUsComment[];
        };
    };

export const reducer = (state: HomePageReducerState, action: Action) => {
    switch (action.type) {
        case ActionEnum.INITIAL_PAGE_COMPLETED: {
            const { locations, specialDeals, promotions, services, talksAboutUsList } = action.payload;

            return {
                ...state,
                loading: false,
                locations,
                specialDeals,
                promotions,
                services,
                talksAboutUsList
            };
        }
        default:
            throw new Error();
    }
};
